import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    destinations: [],
    error: null,
};

export const destinationSlice = createSlice({
    name: "destination",
    initialState: initialState,
    reducers: {

        catchError: (state, action) => {
            state.error = { ...action.payload.error };
            state.loading = false;
        },

        startCall: (state, action) => {
            state.error = null;
            state.loading = true;
            state.destinations = [];
        },

        destinationsFetched: (state, action) => {
            state.loading = false;
            state.destinations = action.payload.destinations;
        },

    }
});
